import axios from 'axios';

const PASSWORD_RESET_ENDPOINT = '/password/reset';
const PASSWORD_RESET_CHECK_ENDPOINT = '/password/reset/check';

export const getEmail = token => {
  return axios.post(PASSWORD_RESET_CHECK_ENDPOINT, { token });
};

export const resetPassword = (token, password) => {
  return axios.post(PASSWORD_RESET_ENDPOINT, { token, password });
};
